
































import {Component, Prop, Vue} from 'vue-property-decorator';
import {ActiveInject, ActiveProvide} from "@/support/reactive"
import JdhInlineLoader from "@/design-system/shared/JdhInlineLoader.vue"
import JdhHeightTransition from "@/design-system/shared/JdhHeightTransition.vue"

/**
 * @status stable
 * @published 4.0.0
 * @changelog 4.0.0 Published.
 */
@Component({
    components: {JdhInlineLoader, JdhHeightTransition}
})
export default class JdsBreakdownItem extends Vue {

    @ActiveInject({from: 'jds.breakdown.stack-items', default: false}) stackContext!: boolean

    /**
     * A short, recognizable label for this piece of information. Try to stick to the Jobilla grammar map.
     *
     * Either this or the #label slot is required. The slot takes priority.
     */
    @Prop({default: ''}) label!: string

    /**
     * If this label has a Jobilla-grammar associated icon, you **must** use it here.
     */
    @Prop() icon!: string

    @Prop({default: false, type: Boolean}) loading!: boolean
    @ActiveProvide('jds.button.type') buttonType = 'tertiary'
    @ActiveProvide('jds.button.size') buttonSize = 'tight'
    @ActiveProvide('jds.button.borderless') buttonBorderless = true
}
